<template>
  <v-container style="height: 100%">
    <v-row no-gutters justify="center" align="start" style="height: 100%">
      <v-card outlined tile
              width="900px">
        <v-progress-linear height="8px" color="parishonline" :value="(currentStep * 10)"></v-progress-linear>

        <div v-if="!hasSubmitted">
          <v-stepper v-model="currentStep" class="elevation-0">
            <v-stepper-items>

              <v-stepper-content step="1">
                <step-one></step-one>
                <navigation-buttons class="mt-4"
                                    unused="back"
                                    :next="!!PARISH"
                                    @back="decreaseStep()"
                                    @next="increaseStep()"
                ></navigation-buttons>
              </v-stepper-content>

              <v-stepper-content step="2">
                <step-two @next="increaseStep()"></step-two>
                <navigation-buttons class="mt-4"
                                    unused="next"
                                    :next="false"
                                    @back="decreaseStep()"
                                    @next="increaseStep()"
                ></navigation-buttons>
              </v-stepper-content>

              <v-stepper-content step="3">
                <step-three></step-three>
                <navigation-buttons class="mt-4"
                                    @back="decreaseStep()"
                                    @next="increaseStep()"
                ></navigation-buttons>
              </v-stepper-content>

              <v-stepper-content step="4">
                <step-four :valid.sync="stepFourValid"></step-four>
                <navigation-buttons class="mt-4"
                                    :next="stepFourValid"
                                    @back="decreaseStep()"
                                    @next="increaseStep()"
                ></navigation-buttons>
              </v-stepper-content>

              <v-stepper-content step="5">
                <step-five :valid.sync="stepFiveValid"></step-five>
                <navigation-buttons class="mt-4"
                                    :next="stepFiveValid"
                                    @back="decreaseStep()"
                                    @next="increaseStep()"
                ></navigation-buttons>
              </v-stepper-content>

              <v-stepper-content step="6">
                <step-six :valid.sync="stepSixValid"></step-six>
                <navigation-buttons class="mt-4"
                                    :next="stepSixValid"
                                    @back="decreaseStep()"
                                    @next="increaseStep()"
                ></navigation-buttons>
              </v-stepper-content>

              <v-stepper-content step="7">
                <step-seven :valid.sync="stepSevenValid"></step-seven>
                <navigation-buttons class="mt-4"
                                    :next="stepSevenValid"
                                    @back="decreaseStep()"
                                    @next="increaseStep()"
                ></navigation-buttons>
              </v-stepper-content>

              <v-stepper-content step="8">
                <step-eight :valid.sync="stepEightValid"></step-eight>
                <navigation-buttons class="mt-4"
                                    :next="stepEightValid"
                                    @back="decreaseStep()"
                                    @next="increaseStep()"
                ></navigation-buttons>
              </v-stepper-content>

              <v-stepper-content step="9">
                <step-nine :valid.sync="stepNineValid"></step-nine>
                <navigation-buttons class="mt-4"
                                    :next="stepNineValid"
                                    @back="decreaseStep()"
                                    @next="increaseStep()"
                ></navigation-buttons>
              </v-stepper-content>

              <v-stepper-content step="10">
                <step-ten :show-form="currentStep === 10"></step-ten>
                <navigation-buttons final class="mt-4"
                                    @back="decreaseStep()"
                                    @submit="handleFinish()"
                ></navigation-buttons>
              </v-stepper-content>

            </v-stepper-items>

          </v-stepper>
        </div>


        <div v-else>

          <div v-if="STATUS === ''">
            <v-row no-gutters justify="center">
              <div class="ma-8">
                <v-row no-gutters justify="center">
                  <v-icon class="custom-loader" size="100" color="success">cached</v-icon>
                </v-row>
                <v-row no-gutters justify="center">
                  <span class="body-1 font-weight-medium">Please wait...</span>
                </v-row>
                <v-row no-gutters justify="center">
                  <span class="body-2">We're signing you up!</span>
                </v-row>
              </div>
            </v-row>
          </div>

          <div v-else-if="STATUS === 'pass'">
            <v-row no-gutters justify="center">
              <div class="ma-8">
                <v-row no-gutters justify="center">
                  <v-icon size="100" color="success">check_circle_outline</v-icon>
                </v-row>
                <v-row no-gutters justify="center">
                  <span class="body-1 font-weight-medium">Thank you for subscribing!</span>
                </v-row>
                <v-row no-gutters justify="center">
                  <span class="body-2">Please check your email to find out how to log in!</span>
                </v-row>
              </div>
            </v-row>
          </div>

          <div v-else-if="STATUS === 'error'">
            <v-row no-gutters justify="center">
              <div class="ma-8">
                <v-row no-gutters justify="center">
                  <v-icon size="100" color="error">error_outline</v-icon>
                </v-row>
                <v-row no-gutters justify="center">
                  <span class="body-1 font-weight-medium">We ran into an issue during subscription!</span>
                </v-row>
                <v-row no-gutters justify="center">
                  <span class="body-2">The most common cause of this is signing up with an email that is already associated with an account.</span>
                </v-row>
                <v-row no-gutters justify="center">
                  <span class="body-2">If you think this is wrong, please message us at
                    <a href="https://www.parish-online.co.uk/support" target="_blank" class="font-weight-medium">support</a>
                    and we will get back to you as soon as possible.</span>
                </v-row>
              </div>
            </v-row>
          </div>


        </div>

      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  import {mapGetters} from "vuex";
  import StepOne from "@/components/steps/StepOne";
  import NavigationButtons from "@/components/NavigationButtons";
  import StepTwo from "@/components/steps/StepTwo";
  import StepThree from "@/components/steps/StepThree";
  import StepFour from "@/components/steps/StepFour";
  import StepFive from "@/components/steps/StepFive";
  import StepSix from "@/components/steps/StepSix";
  import StepSeven from "@/components/steps/StepSeven";
  import StepEight from "@/components/steps/StepEight";
  import StepNine from "@/components/steps/StepNine";
  import StepTen from "@/components/steps/StepTen";
  import * as axe from "axe-core";

  export default {
    name: "MainForm",
    components: {StepTen, StepNine, StepEight, StepSeven, StepSix, StepFive, StepFour, StepThree, StepTwo, NavigationButtons, StepOne},
    props: {},
    data() {
      return {
        currentStep: 1,
        stepFourValid: false,
        stepFiveValid: false,
        stepSixValid: false,
        stepSevenValid: false,
        stepEightValid: false,
        stepNineValid: false,
        hasSubmitted: false,
      }
    },
    computed: {
      ...mapGetters({
        PARISH: 'GET_SELECTED_PARISH',
        PARISH_EXISTS: 'GET_PARISH_EXISTS',
        STATUS: 'GET_RESPONSE_STATUS'
      }),
    },
    methods: {
      increaseStep() {
        if (this.currentStep < 10) {
          this.currentStep = this.currentStep + 1;
        }
      },
      decreaseStep() {
        if (this.currentStep > 1) {
          this.currentStep = this.currentStep - 1;
        }
      },
      handleFinish() {
        this.hasSubmitted = true;
        this.$store.dispatch('CREATE_ACCOUNT');
      },
      handleTest() {
        this.hasSubmitted = true;
        this.$store.dispatch('TEST');
      },
    },
    watch: {},
  }
</script>

<style>
  .v-text-field--outlined fieldset {
    border-width: 1px !important;
  }

  .v-stepper__step__step {
    margin-right: 0px !important;
  }
</style>

<style scoped>

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }

  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(-360deg);
    }
  }

  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(-360deg);
    }
  }

  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(-360deg);
    }
  }

  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(-360deg);
    }
  }
</style>
